import { css } from 'styled-components'

export const mediaL = (...args) => css`
  @media screen and (min-width: 1440px) {
    ${css(...args)};
  }
`
export const mediaM = (...args) => css`
  @media screen and (min-width: 1024px) {
    ${css(...args)};
  }
`
export const mediaS = (...args) => css`
  @media screen and (min-width: 768px) {
    ${css(...args)};
  }
`

export const mediaHover = (...args) => css`
  ${({ theme }) =>
    theme.isOldDesktop
      ? css(...args)
      : css`
          @media (hover: hover) {
            ${css(...args)};
          }
        `};
`

export const mediaNoHover = (...args) => css`
  @media (hover: none) {
    ${css(...args)};
  }
`

export const mediaLandscape = (...args) => css`
  @media screen and (max-width: 700px) and (orientation: landscape) {
    ${css(...args)};
  }
`

export const mediaShort = (...args) => css`
  @media screen and (max-height: 710px) and (orientation: landscape) {
    ${css(...args)};
  }
`
